module.exports = __webpack_public_path__ + "img/contact.4735a2a.png";